export const TransportStates = {
  STOPPED: 0,
  PAUSED: 1,
  PLAYING: 2
}
export const MetronomeStates = {
  STOPPED: 0,
  ACTIVE: 1
}
export const DEFAULT_PIANO_SAMPLE = 73
export const DEFAULT_PLUCK_SAMPLE = 386
export const DEFAULT_BASS_SAMPLE = 392

export const DEFAULT_HAT_SAMPLE = 80
export const DEFAULT_KICK_SAMPLE = 2
export const DEFAULT_SNARE_SAMPLE = 252
export const DEFAULT_CLAP_SAMPLE = 20

export const BEATS_PER_MEASURE = 4
export const TICKS_PER_LOOP = 32 * 48

export const MAX_STEM_COUNT = 32
export const MAX_LOOP_COUNT = 26
export const MAX_BARS_COUNT = 64

export const LOOPBAR_CLAMP_VALUE = 0.125
export const LOOPBAR_CLAMP_VALUE_TICKS = LOOPBAR_CLAMP_VALUE * TICKS_PER_LOOP

export const PLAYHEAD_CLAMP_VALUE = 0.0625
export const PLAYHEAD_CLAMP_VALUE_TICKS = PLAYHEAD_CLAMP_VALUE * TICKS_PER_LOOP
